import { Box, Button, Badge,Tooltip } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from "react";
import BulkPushModal from "../../../Modal/BulkPushModal";
import { getPermissions } from "../../../../app/util";
//  "../../app/util";
const BulkPushButton = (props) => {
    const { app_state, ui_state } = useSelector(state => state.app.current_state);
    const { isRestrictionsRoomType } = app_state.workspace_controls;
    const [pricingCount, setPricingCount] = useState(Object.keys(app_state.roomtype_pricing_overrides).length);
    const [restrictionsCount, setRestrictionsCount] = useState(0);

    const { property_details } = useSelector(state => state.auth.profile);
    const { permissions, index } = getPermissions(property_details, app_state.property_id);


    
    const [compState, setcompState] = useState({ modalOpen: false,
         updateRestrictionCount: 0 });
    // debugger; 
    useEffect(() => {
        let isSubscribed = true;
        console.log(app_state)
        setPricingCount(Object.keys(app_state.roomtype_pricing_overrides).length)
        let restrictionsCount = Object.keys(app_state.savedRestrictions).length + Object.keys(app_state.roomTypeRestrictions).length
        setRestrictionsCount(restrictionsCount);
        return () => (isSubscribed = false);
    }, [app_state.roomtype_pricing_overrides, 
        app_state.savedRestrictions,  
        app_state.roomTypeRestrictions])
    
    const handleClick = () => {
        setcompState(state => {
            return { ...state, modalOpen: true }
        });
        ;
    }

    const handleModalClose = () => {
        compState.modalOpen = false;
        setcompState(state => {
            return { ...state, ...compState }
        });
        
    }

    const { modalOpen, updateRestrictionCount } = compState;
    const count = (isRestrictionsRoomType === true ) ? app_state.roomTypeRestrictions.length : app_state.savedRestrictions.length
  

    let title = "Bulk Restrictions";
    if(ui_state.active_tiles[0] === "pricing"){
        title = "Bulk Pricing"
    }
    let disabled = false;
    let text = "";
    if(pricingCount>0 && ui_state.active_tiles[0] === "pricing"  ){
        disabled = true
        text= "To use the bulk pricing clear the pending decisions in the update cart"
    }
    if( ui_state.active_tiles[0] === "restrictions" && restrictionsCount>0  ){
        disabled = true;
        text= "To use the bulk restrictions clear the pending decisions in for the update cart in all data levels"
    }

    if (permissions.restriction_d && permissions.restriction_d.restriction_room_type === false && permissions.restriction_d.restriction_house === false) {
        disabled = true;
        text= "Hotel Level & Room Type Restrictions is not enabled for this Data Source.";
    }

    return (
        <>
            <Tooltip title={text} >
            <Badge component="div" classes={{badge:'pulse restriction-badge'}}  color="primary" className='btn-ratepush' sx={{ mt: 1.2, mr: 0, position: 'relative' }}>
                
                <Button disabled={disabled} className={'PushRateButton bulk-btn'} size="small" sx={{ m: "auto" }} onClick={handleClick}>
                    
                </Button>
              
            </Badge>
            </Tooltip>
            <BulkPushModal modalOpen={modalOpen} handleModalClose={handleModalClose} />
        </>
    )

}


export default BulkPushButton